import { render, staticRenderFns } from "./DkoSingleToolbarMenu.vue?vue&type=template&id=68ea31d7"
import script from "./DkoSingleToolbarMenu.vue?vue&type=script&lang=js"
export * from "./DkoSingleToolbarMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports